<header
  class="fixed left-0 right-0 z-50 h-[50px] border-b border-gray-200 bg-white transition-all duration-300"
  [style.top]="topOffset()"
  [ngClass]="{
    'lg:left-16': navigationLayout() === 'sidebar' && sidebarCollapsed(),
    'lg:left-[300px]': navigationLayout() === 'sidebar' && !sidebarCollapsed(),
  }"
>
  <nav
    class="relative flex h-full w-full min-w-0 items-center justify-between gap-2 px-2 sm:px-3 md:gap-3 md:px-4 lg:px-6"
    aria-label="Cabeçalho"
  >
    <div class="flex min-w-0 shrink-0 items-center gap-x-2">
      @if (navigationLayout() === 'sidebar') {
      <button
        type="button"
        class="inline-flex size-9 shrink-0 items-center justify-center rounded border border-transparent text-gray-800 hover:bg-gray-100 focus:bg-gray-100 focus:outline-hidden disabled:pointer-events-none disabled:opacity-50 lg:hidden"
        (click)="toggleSidebar.emit()"
        aria-controls="application-sidebar"
        aria-label="Alternar sidebar"
      >
        <span class="sr-only">Alternar sidebar</span>
        <i class="bi bi-list text-lg leading-none" aria-hidden="true"></i>
      </button>
      } @if (navigationLayout() !== 'sidebar') {
      <a
        routerLink="/"
        class="notranslate mr-2 inline-block flex-none focus:outline-hidden focus:opacity-80"
        translate="no"
        aria-label="OneEduca"
      >
        <p class="text-lg font-bold leading-none tracking-tight text-gray-800">
          One<span class="text-[var(--color-primary)]">Educa</span>
        </p>
        <p
          class="mt-0.5 text-[0.5rem] font-medium uppercase leading-none tracking-[0.24em] text-gray-500"
        >
          Admin
        </p>
      </a>
      } @if (navigationLayout() === 'sidebar') {
      <span class="min-w-0 truncate text-sm font-medium text-gray-700">
        {{ title() }}
      </span>
      }
    </div>

    <div class="flex shrink-0 items-center gap-x-2 sm:gap-x-4">
      <button
        type="button"
        class="inline-flex size-9 items-center justify-center rounded border border-gray-300 bg-white text-sm text-gray-500 transition hover:border-gray-400 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-[var(--color-primary-ring)] sm:h-9 sm:w-56 sm:justify-between sm:gap-2 sm:px-3 md:w-64"
        aria-label="Buscar na plataforma"
        [attr.title]="'Buscar (' + searchShortcutLabel + ')'"
        (click)="handleOpenSearch()"
      >
        <span class="inline-flex min-w-0 items-center gap-2">
          <i
            class="bi bi-search shrink-0 text-sm leading-none text-gray-400"
            aria-hidden="true"
          ></i>
          <span class="hidden min-w-0 truncate sm:inline">Buscar</span>
        </span>
        <kbd
          class="hidden shrink-0 rounded border border-gray-200 bg-gray-50 px-1.5 py-0.5 text-[10px] font-medium text-gray-500 sm:inline"
        >
          {{ searchShortcutLabel }}
        </kbd>
      </button>

      <ui-notifications-dropdown
        [items]="notificationItems()"
        [unreadCount]="notificationUnreadCount()"
        [viewAllRoute]="notificationsRoute"
        (dismiss)="handleDismissNotification($event)"
        (navigate)="handleNavigateNotification($event)"
      />

      @if (fullscreenSupported) {
      <div class="relative inline-flex">
        <button
          type="button"
          class="relative inline-flex size-9 items-center justify-center rounded border border-transparent text-gray-700 transition hover:bg-gray-100 focus:bg-gray-100 focus:outline-hidden"
          [attr.aria-label]="
            isFullscreen() ? 'Sair da tela cheia' : 'Entrar em tela cheia'
          "
          [attr.aria-pressed]="isFullscreen()"
          (click)="handleToggleFullscreen()"
        >
          @if (isFullscreen()) {
          <i
            class="bi bi-fullscreen-exit text-lg leading-none"
            aria-hidden="true"
          ></i>
          } @else {
          <i
            class="bi bi-fullscreen text-lg leading-none"
            aria-hidden="true"
          ></i>
          }
        </button>
      </div>
      }

      <div class="relative inline-flex">
        <button
          id="header-user-menu-toggle"
          type="button"
          class="relative inline-flex items-center gap-x-2 text-sm font-medium transition"
          aria-haspopup="menu"
          aria-controls="header-user-menu"
          [attr.aria-expanded]="isUserMenuOpen()"
          aria-label="Menu do usuário"
          (click)="handleToggleUserMenu()"
        >
          <ui-user-avatar
            [name]="userName()"
            [src]="userAvatarUrl()"
            size="xs"
          />
        </button>

        <div
          id="header-user-menu"
          class="absolute end-0 z-60 mt-[40px] min-w-72 rounded border border-gray-200 bg-white p-2 shadow-lg transition-all duration-200 ease-out"
          role="menu"
          aria-labelledby="header-user-menu-toggle"
          [ngClass]="{
            'pointer-events-none translate-y-1 opacity-0': !isUserMenuOpen(),
            'translate-y-0 opacity-100': isUserMenuOpen(),
          }"
        >
          <div
            class="mb-2 flex items-center gap-3 border-b border-gray-200 px-2 pb-3 pt-1"
          >
            <ui-user-avatar [name]="userName()" [src]="userAvatarUrl()" />
            <div class="min-w-0">
              <p class="truncate text-sm font-semibold text-gray-800">
                {{ userName() }}
              </p>
              <p class="truncate text-xs text-gray-500">
                {{ userRoleLabel() }}
              </p>
            </div>
          </div>

          @if (loginCandidates().length > 0) {
          <div class="mb-2 border-b border-gray-200 px-2 pb-3">
            <label
              for="header-switch-user"
              class="mb-1 block text-xs font-medium text-gray-500"
            >
              Ver como (demo)
            </label>
            <select
              id="header-switch-user"
              class="block w-full rounded border border-gray-300 bg-white px-2 py-1.5 text-sm text-gray-800"
              [value]="currentUserId()"
              (change)="onSwitchUserChange($event)"
            >
              @for (candidate of loginCandidates(); track candidate.id) {
              <option [value]="candidate.id">
                {{ candidate.name }} - {{ roleLabels[candidate.role] }}
              </option>
              }
            </select>
          </div>
          }

          <a
            routerLink="/profile"
            class="flex items-center gap-x-3 rounded px-3 py-2 text-sm text-gray-700 hover:bg-gray-100"
            (click)="handleCloseUserMenu()"
          >
            <i
              class="bi bi-person-circle text-base leading-none"
              aria-hidden="true"
            ></i>
            Meu perfil
          </a>

          <a
            class="flex items-center gap-x-3 rounded px-3 py-2 text-sm text-gray-700 hover:bg-gray-100"
            href="#"
            (click)="onLogoutClick($event)"
          >
            Sair
          </a>
        </div>
      </div>
    </div>
  </nav>
</header>

<app-platform-search-dialog
  [open]="isSearchOpen()"
  [role]="searchRole()"
  [groupNavMode]="searchGroupNavMode()"
  (closed)="handleCloseSearch()"
/>
